// extracted by mini-css-extract-plugin
module.exports = {"header":"CarSummary_header__g_mgO","list":"CarSummary_list__40665"};